/**
 * Toast Notification Types
 *
 * Type definitions for the toast notification system.
 * Toasts are non-blocking, bottom-right stacked notifications.
 */

/**
 * Toast type variants - determines icon and color scheme
 */
export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  LOADING = 'loading',
  INFO = 'info',
  WARNING = 'warning',
}

/**
 * Toast notification configuration
 */
export interface Toast {
  /** Unique identifier (auto-generated if not provided) */
  id: string;

  /** Toast type - affects icon and styling */
  type: ToastType;

  /** Primary message (required) */
  title: string;

  /** Optional secondary message for more detail */
  message?: string;

  /**
   * Auto-dismiss duration in milliseconds
   * - null = manual dismiss only (for loading states)
   * - number = auto-dismiss after duration
   * Default: 3000 for success, 5000 for error, null for loading
   */
  duration?: number | null;

  /**
   * Optional action button
   */
  action?: {
    label: string;
    onClick: () => void;
  };

  /**
   * Timestamp when toast was created
   */
  created_at: number;
}

/**
 * Options for creating a toast
 */
export interface ToastOptions {
  /** Optional custom ID (useful for updating toasts) */
  id?: string;

  /** Optional secondary message */
  message?: string;

  /** Auto-dismiss duration (overrides default) */
  duration?: number | null;

  /** Optional action button */
  action?: {
    label: string;
    onClick: () => void;
  };
}
